import { Stack } from '@mui/material';
import { ReactNode } from 'react';

interface ToolbarActionGroupProps {
    children: ReactNode;
}

/**
 * ツールバー内でアクションボタンなどをグループ化して表示するためのコンポーネント
 * レスポンシブ対応で、小さい画面では折り返し、大きい画面では右寄せで表示されます
 */
export const ToolbarActionGroup = ({ children }: ToolbarActionGroupProps) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        justifyContent: 'flex-end',
        width: 'auto'
      }}
    >
      {children}
    </Stack>
  );
};

